import { ConfigProvider as AntdLocaleProvider } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { IntlProvider } from 'react-intl';
import { connect } from 'react-redux';
import moment from 'utils/cops-moment';
import {
  DEFAULT_LOCALE,
  antdLocaleData,
  cacheLocale,
  flattenMessages,
} from 'utils/i18n';
import useCachedStateData from '../../utils/hooks/useCachedStateData';
import {
  fetchSupportedLanguagesRequest,
  fetchSupportedLanguagesSuccess,
  fetchTranslationsRequest,
  fetchTranslationsSuccess,
  setLocale,
} from './language-provider-actions';

const LanguageProvider = ({
  locale,
  translations,
  children,
}) => {
  useCachedStateData(
    'compressedTranslations',
    fetchTranslationsRequest,
    locale || 'en-GB',
    'languageProvider.translations',
    fetchTranslationsSuccess,
    null,
    !JSON.parse(localStorage.getItem('definitionModeEnabled')),
  );

  useCachedStateData(
    'compressedLanguageDefinitions',
    fetchSupportedLanguagesRequest,
    null,
    'languageProvider.supportedLanguages',
    fetchSupportedLanguagesSuccess,
    null,
    true,
  );

  useEffect(() => {
    moment.locale(locale);
    cacheLocale(locale);
  }, []);

  return (
    <IntlProvider
      defaultLocale={DEFAULT_LOCALE}
      locale={locale}
      messages={flattenMessages(translations)}
      key={locale}
    >
      <AntdLocaleProvider locale={antdLocaleData[locale]}>
        {children}
      </AntdLocaleProvider>
    </IntlProvider>
  );
};

const mapStateToProps = state => ({
  locale: state.languageProvider.locale,
  translations: state.languageProvider.translations,
});

const mapDispatchToProps = {
  setLocale,
};

LanguageProvider.propTypes = {
  locale: PropTypes.string,
  children: PropTypes.node.isRequired,
  fetchTranslations: PropTypes.func,
  translations: PropTypes.object,
  fetchSupportedLanguages: PropTypes.func,
};


export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LanguageProvider);
